import React from "react";
import { Route, Switch } from "react-router-dom";
import NotFound from "./NotFound/NotFound";
import NotAuthorized from "./NotFound/Authorize";
import MonthlyPlanList from "./MounthlyPlan/MonthlyPlanList";
import MonthlyPlanTypeList from "./MonthlyPlanType/MonthlyPlanTypeList";
import FirmList from "./Firm/FirmList";
import FirmAccountList from "./FirmAccount/FirmAccountList";
import PasswordChange from "./Password/Change";
import UserList from "./User/UserList";
import UserRoleList from "./User/UserRoles";
import UserAccountsRoles from "./User/UserAccountRoles";
import EntityPermissions from "./User/EntityPermissions";
import TenantParameter from "./TenantParameter";
import { useMediaQuery } from "react-responsive";

import TableTransactionRole from "./TableRole/TableTransactionRole";

import HomePage from "./HomePage";
import StockHome from "./HomePage/Pages/StockHome";

import FirmMonthlyStatusReportPage from "./Report/FirmMonthlyPaymentStatusReport";
import FirmTransactionsList from "./Firm/FirmTransactionsList";
import StockList from "./Stock/StockList";
import StockMovementByStockList from "./Stock/StockMovementByStockList";
import StockPriceHistoryByStockList from "./Stock/StockPriceHistoryByStockList";
import StockPriceHistoryReport from "./Report/StockPriceHistoryReport";
import StockMovementHistoryReport from "./Report/StockMovementHistoryReport";
import EmployeeList from "./Employee/EmployeeList";
import EmployeeTransactionsList from "./Employee/EmployeeTransactionsList";
import EmployeeTransactionsReport from "./Employee/EmployeeTransactionsReport";
import TransactionProjectTypeList from "./TransactionProjectType/TransactionProjectTypeList";
import StockTransactionProjectTypeByStockList from "./Stock/StockTransactionProjectTypeByStockList";
import StockTransactionProjectTypeByTransactionProjectTypeList from "./Stock/StockTransactionProjectTypeByTransactionProjectTypeList";
import StockTransactionProjectTypeReport from "./Stock/StockTransactionProjectTypeReport";
import ProjectStepByProjectList from "./Project/ProjectStepByProjectList";
import ProjectStepNoteByProjectStepList from "./Project/ProjectStepNoteByProjectStepList";

import PurchaseRequestList from "./PurchaseRequest/PurchaseRequestList";
import CreatePurchaseRequest from "./PurchaseRequest/CreatePurchaseRequest";
import UpdatePurchaseRequest from "./PurchaseRequest/UpdatePurchaseRequest";

import CreateQuote from "./Quote/CreateQuote";
import QuoteList from "./Quote/QuoteList";
import UpdateQuote from "./Quote/UpdateQuote";

import CreateOrder from "./Order/CreateOrder";
import OrderList from "./Order/OrderList";
import UpdateOrder from "./Order/UpdateOrder";

import SupplierList from "./Supplier/SupplierList";
import MaterialList from "./Material/MaterialList";
import MaterialCategoryList from "./Material/MaterialCategoryList";
import OrderDeliveryList from "./OrderDelivery/OrderDeliveryList";
import OrderWaitingByTransactionProjectTypeList from "./Order/OrderWaitingByTransactionProjectTypeList";
import FirmTransactionProjectTypeByFirmList from "./Firm/FirmTransactionProjectTypeByFirmList";
import FirmApprovalAssignmentList from "./Firm/FirmApprovalAssignmentList";
import ProjectCostReportByProjectList from "./Project/ProjectCostReportByProjectList";

const App = ({ match }) => (
  <div
    className="gx-main-content-wrapper"
    style={{
      backgroundColor: "white",
      width: useMediaQuery({
        query: "(max-width: 1070px)",
      })
        ? ""
        : "99%",
    }}
  >
    <Switch>
      {/* Anasayfa */}
      {/* <Route path={`${match.url}`} component={asyncComponent(() => import('./HomePage/index'))}/> */}
      <Route path={`${match.url}home`} component={HomePage} />
      <Route path={`${match.url}home-stock`} component={StockHome} />

      {/* {TABLO YETKİ} */}
      <Route
        path={`${match.url}table-transaction-role`}
        component={TableTransactionRole}
      />

      {/*Aylık Plan Listesi */}
      <Route
        path={`${match.url}monthly-plan-list`}
        component={MonthlyPlanList}
      />

      {/* Aylık Plan Tipi*/}
      <Route
        path={`${match.url}monthly-plan-type-list`}
        component={MonthlyPlanTypeList}
      />

      {/* Firma Listesi */}
      <Route path={`${match.url}firm-list`} component={FirmList} />
      {/* Firma Hesapları */}
      <Route
        path={`${match.url}firm-account-list/:firmId?`}
        component={FirmAccountList}
      />

      <Route
        path={`${match.url}firm-transaction-list/:firmId`}
        component={FirmTransactionsList}
      />

      <Route
        path={`${match.url}firm-approval-assignment/:firmId/:firmName?`}
        component={FirmApprovalAssignmentList}
      />

      {/* Şifre Değiştir */}
      <Route path={`${match.url}password-change`} component={PasswordChange} />
      {/* Kullanıcı Yetkiler */}
      <Route path={`${match.url}user-list`} component={UserList} />
      <Route path={`${match.url}user-roles/:userId`} component={UserRoleList} />
      <Route
        path={`${match.url}user-accounts-roles/:userId`}
        component={UserAccountsRoles}
      />
      <Route
        path={`${match.url}entity-permission/:tenantUserId`}
        component={EntityPermissions}
      />

      <Route
        exact
        path={`${match.url}report-firm-monthly-payment/:firmid/:transactionDate?/:transactionDate2/:currency`}
        component={FirmMonthlyStatusReportPage}
      />

      {/* Depo */}
      <Route
        exact
        path={`${match.url}transaction-project-type`}
        component={TransactionProjectTypeList}
      />

      {/* Stok Takip */}
      <Route exact path={`${match.url}stock-list`} component={StockList} />
      <Route
        exact
        path={`${match.url}stock-movement-history/:stockId`}
        component={StockMovementByStockList}
      />
      <Route
        exact
        path={`${match.url}stock-price-history/:stockId`}
        component={StockPriceHistoryByStockList}
      />
      <Route
        exact
        path={`${match.url}stock-price-history-report`}
        component={StockPriceHistoryReport}
      />
      <Route
        exact
        path={`${match.url}stock-movement-history-report`}
        component={StockMovementHistoryReport}
      />
      <Route
        exact
        path={`${match.url}stock-storage/:stockId`}
        component={StockTransactionProjectTypeByStockList}
      />
      <Route
        exact
        path={`${match.url}storage-stock/:transactionProjectTypeId`}
        component={StockTransactionProjectTypeByTransactionProjectTypeList}
      />

      <Route
        exact
        path={`${match.url}storage-stock-report`}
        component={StockTransactionProjectTypeReport}
      />
      {/* Çalışan */}
      <Route
        exact
        path={`${match.url}employee-list`}
        component={EmployeeList}
      />
      <Route
        path={`${match.url}employee-transaction-list/:firmId`}
        component={EmployeeTransactionsList}
      />
      <Route
        path={`${match.url}employee-transaction-report`}
        component={EmployeeTransactionsReport}
      />

      {/* Proje */}

      <Route
        exact
        path={`${match.url}project-step/:firmId`}
        component={ProjectStepByProjectList}
      />

      <Route
        exact
        path={`${match.url}project-step-note/:projectStepId`}
        component={ProjectStepNoteByProjectStepList}
      />

      <Route
        exact
        path={`${match.url}firm-storage/:firmId/:firmName?`}
        component={FirmTransactionProjectTypeByFirmList}
      />

      <Route
        exact
        path={`${match.url}project-cost-report-by-project/:firmId`}
        component={ProjectCostReportByProjectList}
      />

      {/* Satın Alma */}
      <Route
        exact
        path={`${match.url}purchase-request-list`}
        component={PurchaseRequestList}
      />

      <Route
        exact
        path={`${match.url}create-purchase-request`}
        component={CreatePurchaseRequest}
      />

      <Route
        exact
        path={`${match.url}update-purchase-request/:id`}
        component={UpdatePurchaseRequest}
      />

      {/* Teklif */}
      <Route exact path={`${match.url}quote-list`} component={QuoteList} />

      <Route exact path={`${match.url}create-quote`} component={CreateQuote} />

      <Route
        exact
        path={`${match.url}update-quote/:id`}
        component={UpdateQuote}
      />

      {/* Sipariş */}
      <Route exact path={`${match.url}order-list`} component={OrderList} />

      <Route exact path={`${match.url}create-order`} component={CreateOrder} />

      <Route
        exact
        path={`${match.url}order-delivery-list`}
        component={OrderDeliveryList}
      />

      <Route
        exact
        path={`${match.url}update-order/:id`}
        component={UpdateOrder}
      />

      <Route
        exact
        path={`${match.url}order-waiting-by-transaction-project-type/:transactionProjectTypeId`}
        component={OrderWaitingByTransactionProjectTypeList}
      />

      {/* Tedarikçi */}
      <Route
        exact
        path={`${match.url}supplier-list`}
        component={SupplierList}
      />

      {/* Malzeme */}
      <Route
        exact
        path={`${match.url}material-list`}
        component={MaterialList}
      />
      {/* Malzeme Kategori */}
      <Route
        exact
        path={`${match.url}material-cateogry-list`}
        component={MaterialCategoryList}
      />

      {/* Error */}
      <Route
        exact
        path={`${match.url}not-authorized-access`}
        component={NotAuthorized}
      />

      <Route
        path={`${match.url}tenant-parameter`}
        component={TenantParameter}
      />
      <Route component={NotFound} />
    </Switch>
  </div>
);

export default App;
